var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return (_vm.props.user && _vm.$options.m.status(_vm.props) !== '')?_c('span',{staticClass:"kiwi-typingstatusindicator",class:( _obj = {
        'kiwi-typingstatusindicator--paused': _vm.$options.m.status(_vm.props) === 'paused'
    }, _obj[_vm.data.staticClass] = true, _obj )},[_vm._v("…")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }